import React, { useState } from 'react';

import { Box, Modal, Typography, useMediaQuery } from '@mui/material';

import DonquijoteLogo from '../shared/icons/DonquijoteLogo';

import EquipoRecomendacionJugadores from './EquipoRecomendacionJugadores';
import UltimaActualizacionComponent from './UltimaActualizacionComponent';
import ExportTierlistToPNG from '../tierlist/visualizar-tierlist/export-tierlists';

const EquipoPredictionsModal = ({ players, targetId, updatedAt, teamName }) => {
    const isSmallScreen = useMediaQuery('(max-width:420px)');
    const [predictionsAvailable, setPredictionsAvailable] = useState(false);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    React.useEffect(() => {
        if (players?.length > 0) {
            let isPredictionVisible = false;

            players?.forEach((player) => {
                if (
                    player?.isAriete ||
                    player?.isBufon ||
                    player?.isCapitan ||
                    player?.isChollo ||
                    player?.isNoInscrito ||
                    player?.isRevulsivo
                ) {
                    isPredictionVisible = true;
                }
            });

            setPredictionsAvailable(isPredictionVisible);
        }
    }, [players]);

    return (
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box
                onClick={predictionsAvailable ? handleOpen : undefined}
                style={{
                    color: '#000',
                    display: 'flex',
                    gap: '4px',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textDecoration: 'underline',
                    opacity: predictionsAvailable ? 1 : 0.5,
                }}
            >
                <DonquijoteLogo width={20} />
                <Typography
                    sx={{ position: 'relative', top: '1px', textDecoration: 'underline', fontSize: '14px' }}
                >
                    DonquiPicks
                </Typography>
            </Box>
            <Box display={'flex'}>
                <UltimaActualizacionComponent date={updatedAt} />
                <ExportTierlistToPNG
                    targetId={targetId}
                    defaultTitle={`Alineación probable de ${teamName}`}
                    width={550}
                    showTitle={false}
                    icon={true}
                />
            </Box>

            <Modal open={open} onClose={handleClose}>
                <Box
                    display="flex"
                    flexDirection="column"
                    position="absolute"
                    top="120px"
                    left={isSmallScreen ? '5%' : 'calc(50% - 200px)'}
                    transform="translate(-50%, -50%)"
                    bgcolor="background.paper"
                    borderRadius={'4px'}
                    boxShadow={24}
                    width={isSmallScreen ? '90vw' : '400px'}
                    maxHeight="90vh"
                    overflow="auto"
                >
                    <EquipoRecomendacionJugadores players={players} handleClose={handleClose} />
                </Box>
            </Modal>
        </Box>
    );
};

export default EquipoPredictionsModal;
